// Projects data - Updated with real projects from resume
export const projects = [
  {
    id: 1,
    title: 'HELIX METAVERSE',
    description: 'Led development of a massive multiplayer metaverse platform valued at $20M+. Engineered custom pedestrian and vehicle traffic AI, managed replication and multiplayer networking systems, integrated Metahuman technology, and directed a team of 20+ employees.',
    image: '/images/wordpress/portfolio-01.jpg',
    tags: ['Unreal Engine', 'C++', 'Multiplayer', 'AI', 'Metaverse', 'Metahuman'],
    category: 'game',
    link: '#',
    github: '#',
    featured: true,
    year: '2021-2022',
    technologies: ['Unreal Engine 5', 'C++', 'Multiplayer Networking', 'AI Systems', 'AWS'],
    company: 'Hypersonic Labs',
    highlights: [
      'Project valued at $20M+',
      'Custom AI traffic systems',
      'Metahuman integration',
      'Led team of 20+ developers',
    ],
  },
  {
    id: 2,
    title: 'TOXIC TWIGHTS',
    description: 'Spearheaded development with scalable dynamic scoreboard, dynamic locomotion system, and fully runtime dynamic cover/vault/climbing system. Created ultra-realistic XR environment for live production television commercials.',
    image: '/images/wordpress/alongsideglobal_logo.jpg',
    tags: ['Unreal Engine', 'C++', 'XR', 'Multiplayer', 'Gameplay Systems'],
    category: 'game',
    link: '#',
    github: '#',
    featured: true,
    year: '2023',
    technologies: ['Unreal Engine 5', 'C++', 'XR', 'Dynamic Systems', 'Live Production'],
    company: 'AlongSide/Global & Sombra Network',
    highlights: [
      'Ultra-realistic XR environments',
      'Runtime dynamic systems',
      'Live production integration',
      'Scalable architecture',
    ],
  },
  {
    id: 3,
    title: 'BATTLE ROOM',
    description: 'Integrated Online Subsystem Steam API and Steamworks. Developed multiplayer matchmaking system with dedicated servers and host migration capabilities.',
    image: '/images/wordpress/HighresScreenshot00048.png',
    tags: ['Unreal Engine', 'C++', 'Steam', 'Multiplayer', 'Matchmaking'],
    category: 'game',
    link: '#',
    github: '#',
    featured: false,
    year: '2024',
    technologies: ['Unreal Engine', 'C++', 'Steam API', 'Dedicated Servers', 'Matchmaking'],
    company: 'Axhorn Games',
    highlights: [
      'Steam integration',
      'Dedicated server architecture',
      'Host migration system',
      'Matchmaking system',
    ],
  },
  {
    id: 4,
    title: 'SHRAPNEL FPS',
    description: 'Developed and implemented custom C++ extraction point game mode. Spearheaded player data integration efforts ensuring seamless connectivity across gaming platforms. Conducted extensive debugging and networking optimization.',
    image: '/images/wordpress/portfolio-02.jpg',
    tags: ['Unreal Engine', 'C++', 'FPS', 'Multiplayer', 'Game Modes'],
    category: 'game',
    link: '#',
    github: '#',
    featured: false,
    year: '2022',
    technologies: ['Unreal Engine', 'C++', 'Multiplayer Networking', 'Game Modes'],
    company: 'Shrapnel',
    highlights: [
      'Custom game mode development',
      'Cross-platform integration',
      'Network optimization',
      'Player data systems',
    ],
  },
  {
    id: 5,
    title: 'PINKSLIP CITY',
    description: 'Led development efforts overseeing all aspects from conception to execution. Engineered hyper-realistic Porsche with sophisticated launch control system and immersive FMod sound design. Managed multiplayer networking and AWS infrastructure.',
    image: '/images/wordpress/portfolio-03.jpg',
    tags: ['Unreal Engine', 'C++', 'Racing', 'Multiplayer', 'Audio'],
    category: 'game',
    link: '#',
    github: '#',
    featured: false,
    year: '2021-2022',
    technologies: ['Unreal Engine', 'C++', 'FMod', 'Multiplayer', 'AWS'],
    company: '3D CityScapes',
    highlights: [
      'Hyper-realistic vehicle physics',
      'FMod audio integration',
      'Launch control system',
      'Full project leadership',
    ],
  },
  {
    id: 6,
    title: 'NIFTYVILLE & HODLGOD',
    description: 'Led development initiatives overseeing 60+ member team and spearheading project planning. Executed extensive custom artificial intelligence work. Managed multiplayer networking, replication, and AWS server architecture.',
    image: '/images/wordpress/1a92ac619f9fbcf1787897a10c4f6825.jpg',
    tags: ['Unreal Engine', 'C++', 'AI', 'Multiplayer', 'Web3'],
    category: 'game',
    link: '#',
    github: '#',
    featured: false,
    year: '2021-2022',
    technologies: ['Unreal Engine', 'C++', 'AI Systems', 'Multiplayer', 'AWS', 'Web3'],
    company: 'Onessus',
    highlights: [
      'Led 60+ member team',
      'Custom AI systems',
      'Web3 integration',
      'Large-scale architecture',
    ],
  },
  {
    id: 7,
    title: 'APEING.AI & STREAM.FUN',
    description: 'Amazon IVS video streaming services for live streaming/trade platform. TradingView & Trading components. Elixir/Phoenix chat with full custom administrative tools. Full seamless web3 wallet integration. AWS management and backend services.',
    image: '/images/wordpress/SombraNetwork-1786797164250722670.mp4',
    tags: ['Full Stack', 'React', 'Elixir', 'Web3', 'AWS', 'Streaming'],
    category: 'web',
    link: '#',
    github: '#',
    featured: true,
    year: '2025',
    technologies: ['React', 'TypeScript', 'Elixir', 'Phoenix', 'AWS IVS', 'Web3', 'TradingView'],
    company: 'APEING.AI & STREAM.FUN',
    highlights: [
      'Live video streaming platform',
      'Trading integration',
      'Elixir/Phoenix backend',
      'Web3 wallet integration',
    ],
  },
  {
    id: 8,
    title: 'Deepline AI',
    description: 'Advanced AI-powered development assistant with code generation, analysis, and intelligent context awareness. Features real-time collaboration, multi-model support, and seamless IDE integration.',
    image: '/images/wordpress/deepline.gif',
    tags: ['React', 'AI', 'TypeScript', 'Three.js', 'Python', 'Machine Learning'],
    category: 'ai',
    link: 'https://deepline.ai',
    github: 'https://github.com/jarradtotman/deepline',
    featured: true,
    year: '2024',
    technologies: ['React', 'TypeScript', 'Python', 'TensorFlow', 'Three.js', 'OpenAI API'],
    company: 'Personal Project',
    highlights: [
      'AI code generation',
      'Multi-model support',
      'Real-time collaboration',
      'IDE integration',
    ],
  },
  {
    id: 9,
    title: 'THUG.TV Metaverse',
    description: 'Immersive 3D metaverse platform with real-time communication, social features, and Web3 integration. Built with Three.js for stunning 3D experiences and WebRTC for seamless voice/video chat.',
    image: '/images/wordpress/jtlogo.png',
    tags: ['React', 'Three.js', 'Web3', 'WebRTC', 'Blockchain'],
    category: 'web3',
    link: 'https://thug.tv',
    github: 'https://github.com/jarradtotman/thugtv',
    featured: true,
    year: '2024',
    technologies: ['React', 'Three.js', 'WebRTC', 'Ethereum', 'IPFS'],
    company: 'Personal Project',
    highlights: [
      '3D metaverse platform',
      'WebRTC integration',
      'Web3 features',
      'Real-time communication',
    ],
  },
]
